import React, { useContext } from 'react';

import { ViewerContext } from 'common/containers/ViewerContainer';
import ButtonLink from 'common/uiV3/Button/ButtonLink';

type Props = {
  installLink: string;
  installButtonText?: string;
};
const InstallExtensionButton = ({
  installLink,
  installButtonText = 'Install Extension',
}: Props) => {
  const viewer = useContext(ViewerContext);

  if (!viewer || viewer.loggedOut || viewer.companies?.length === 0) {
    // logged out || no companies -> register
    return (
      <ButtonLink to="/register" size="large">
        Get started
      </ButtonLink>
    );
  }

  // logged in && has company -> admin dashboard (assume first company for now)
  return (
    <ButtonLink href={installLink} rel="noopener" target="_blank" size="large">
      {installButtonText}
    </ButtonLink>
  );
};

export default InstallExtensionButton;
